import React, { useState } from "react";
import "./index.less";
import {
  add,
  bfl,
  douyin,
  dzl_w,
  fx_w,
  pl_w,
  ratio,
  heat,
  play,
  like,
  sc_w,
} from "@/assets/Inspiration-center";
import { Message, Spin } from "@arco-design/web-react";
import {
  getHotspotId,
  getScriptReader,
  getUpInfo,
} from "@/services/creativeScript/explosiveScript";
import { useNavigate } from "react-router-dom";
interface IIndustryCardProps {
  item?: {
    avatar_url: string;
    comment_cnt: string;
    item_cover_url: string;
    item_duration: number;
    item_id: string;
    item_title: string;
    item_url: string;
    like_cnt: string;
    like_rate: number;
    new_like_cnt: number;
    new_play_cnt: number;
    nick_name: string;
    score: number;
    share_cnt: string;
    author_id: string;
    type?: string;
    share_url: string;
    collect_count?: number;
    comment_count?: number;
    tag?: string;
  };
}
function formatNumber(num) {
  if (!num) {
    return 0;
  }
  if (num >= 10000) {
    // 将数字除以10000，获得万为单位的数值
    let result = num / 10000;

    // 保留小数点后两位
    result = Math.floor(result * 10) / 10;

    // 如果小数部分是 .00，则去掉小数
    if (result === Math.floor(result)) {
      result = Math.floor(result);
    }

    return result + "w";
  }
  return num.toString(); // 小于10000的数字直接返回字符串
}

const IndustryCard: React.FC<IIndustryCardProps> = (props) => {
  const {
    avatar_url,
    comment_cnt,
    item_cover_url,
    item_duration,
    item_id,
    item_title,
    item_url,
    like_cnt,
    like_rate,
    new_like_cnt,
    new_play_cnt,
    nick_name,
    score,
    share_cnt,
    type,
    author_id,
    share_url,
    collect_count,
    comment_count,
    tag,
  } = props.item || {};

  const navigat = useNavigate();
  const myStats = [
    { icon: sc_w, value: formatNumber(collect_count) },
    { icon: dzl_w, value: formatNumber(like_cnt) },
    { icon: pl_w, value: formatNumber(comment_count) },
    { icon: fx_w, value: formatNumber(share_cnt) },
  ];

  const otherStats = [
    { icon: heat, value: formatNumber(score) },
    { icon: bfl, value: formatNumber(new_play_cnt) },
    { icon: dzl_w, value: formatNumber(new_like_cnt) },
    { icon: like, value: (like_rate * 100).toFixed(2) + "%" },
  ];
  const [getUpLoading, setGetUpLoading] = useState<boolean>(false);
  const [getUpId, setGetUpId] = useState("");
  const handleScriptReader = async (data) => {
    const res = await getScriptReader(data);
    setGetUpLoading(false);
    if (res?.code !== 0 || !res.data.id) {
      Message.error(res);
      setGetUpId("");
    } else {
      Message.success("订阅成功, 新订阅账号的视频收集大约需要 1 天");
    }
  };
  const renderStats = (stats) => (
    <div className="industry-num">
      {stats.map((stat, index) => (
        <div key={index}>
          <img src={stat.icon} alt="" />
          <span>{stat.value}</span>
        </div>
      ))}
    </div>
  );

  const handleGetUpInfo = async (sec_user_id, item_id = "") => {
    setGetUpId(item_id);
    setGetUpLoading(true);
    const author = await getHotspotId(item_id);
    if (author?.code == 0 && author.data.author_id) {
      const res = await getUpInfo(author.data.author_id);
      if (res?.code == 0 && res.data.item) {
        const { avatar_url, nickname, sec_uid, unique_id } = res.data.item;
        handleScriptReader({
          nick_name: nickname,
          third_uuid: unique_id,
          sec_uid,
          avatar_url,
          platform: 1,
        });
      } else {
        setGetUpLoading(false);
        setGetUpId("");
        Message.error(JSON.stringify(res));
      }
    } else {
      setGetUpLoading(false);
      setGetUpId("");
      Message.error(JSON.stringify(author));
    }
  };
  return (
    <div className="industry-card">
      <div className="industry-img">
        {tag ? <div className="industry-tag">{tag}</div> : <></>}
        <div
          className="industry-platform"
          onClick={() => {
            navigat(`/analysis-video`, { state: share_url });
          }}>
          AI
        </div>
        <img width={"100%"} src={item_cover_url} alt="" />
        <img
          src={play}
          width={43}
          className="play"
          alt=""
          onClick={() => {
            window.open(share_url, "_blank");
          }}
        />
        {type == "my" ? renderStats(myStats) : renderStats(otherStats)}
      </div>
      <div className="industry-info">
        <p className="industry-title">{item_title || `暂无`}</p>
        <div className="industry-bottom">
          <div>
            <img className="img" src={avatar_url} alt="" />
            <p>{nick_name || `---`}</p>
          </div>
          {type != "my" ? (
            <Spin loading={getUpId == item_id && getUpLoading}>
              <div
                className="subscription-btn"
                onClick={() => {
                  handleGetUpInfo(author_id, item_id);
                }}>
                <img src={add} alt="" width={9} />
                订阅
              </div>
            </Spin>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default IndustryCard;
